import { Input } from '@nextui-org/react';
import React from 'react';


const NextInputBox = ({ placeholder, value, onChange, readonly, type, name, label, labelPlacement, size ,required}) => {
    return (
        <Input
            isRequired={required}
            placeholder={placeholder}
            value={value}
            size={size}
            name={name}
            type={type}
            label={label}
            isReadOnly={readonly}
            labelPlacement={labelPlacement}
            className=""
            onChange={(e) => onChange(e)}
            startContent={
                <div className="pointer-events-none flex items-center">
                  <span className="text-default-400 text-small"></span>
                </div>
              }
        />
    );
};

export default NextInputBox;
